// extracted by mini-css-extract-plugin
module.exports = {"form":"CheckoutForm_form__rXnxL","paymentElement":"CheckoutForm_paymentElement__9EQF0"};